import React from "react";
import "./App.css";
import Row from "./Components/Row";
import request from "./requests/requset";
import Header from "./Components/Header";
import Nav from "./Components/Nav";

function App() {
  return (
    <>
      <div className="App">
        <Nav />
        <Header />
        <Row
          title="NETFLIX ORIGINALS"
          isRowBig
          fetchUrl={request.fetchNetfilxOriginals}
        />
        <Row title="TRENDING NOW" fetchUrl={request.fetchTrending} />
        <Row title="TOP RATED" fetchUrl={request.fetchTopRated} />
        <Row title="ACTION MOVIES" fetchUrl={request.fetchActionMovies} />
        <Row title="COMEDY MOVIES" fetchUrl={request.fetchComedyMovies} />
        <Row title="HORROR MOVIES" fetchUrl={request.fetchHorrorMovies} />
        <Row title="ROMANCE MOVIES" fetchUrl={request.fetchRomanceMovies} />
        <p className="footer_title">@Sonu Sharma</p>
      </div>
    </>
  );
}

export default App;
